module.exports = __webpack_public_path__ + "static/media/landing-age-hero-img.8dc60490.png";